module.exports = __webpack_public_path__ + "img/MY-B2K4060C-AD-HQ.aed04bea.png";